module.exports = __webpack_public_path__ + "img/404.54a62642.png";